<div #filterBlock [class.active]="isOpenFilter" class="filter-block">
  <button (click)="closeFilterBlock()" class="filter-block__close">
    <img
      src="assets/img/close-modal.svg"
      alt="Close"
      class="modal__close-icon"
    />
  </button>
  <h2 class="filter-block__title">{{ 'FILTERS.HEADLINE' | translate }}</h2>
  <div class="scroll-block">
    <ng-content></ng-content>
    <div
      [class.hide]="!additional"
      class="filter-block__parameters">
      <label class="filter-block__parameters-input-block">
        <input
          #searchInput
          (input)="searchDataBase(searchInput.value)"
          [(ngModel)]="searchValue"
          (ngModelChange)="onValueChange($event)"
          type="text"
          placeholder='{{("FILTERS.FIND" | translate) + type}}'
          class="input"
        />
        <img src="assets/img/input-search.svg" alt="Icon" class="icon" />
        <ul
          *ngIf="!!searchTypeFilter"
          [class.active]="searchFilterResult.length !== 0"
          class="search-list"
        >
          <li
            *ngFor="let item of searchFilterResult"
            (click)="selectValue(item)"
            class="search-list__item"
          >
            {{ item.description }}
          </li>
        </ul>
      </label>
      <app-filter-select
        *ngIf="additional"
        (setAdditionalType)="setAdditionalType($event)"
        [isAdditional]="true"
        [filterTitle]="'additional_params'"
        [filter]="additional"
      >
      </app-filter-select>
    </div>
    <div class="filter-block__filtering">
      <ul class="filter-block__filtering-list">
        <li *ngFor="let item of filterData" class="item">
          <span class="item__title">{{
            'FILTERS.' + item.fieldName | translate
          }}</span>
          <span class="item__value">{{ item.description }}</span>
          <button (click)="deleteFilter(item)" class="item__delete">
            <img
              src="assets/img/close-modal.svg"
              alt="Icon"
              class="item__delete-image"
            />
          </button>
        </li>
      </ul>
    </div>
  </div>
  <div class="filter-block__btn-block">
    <button
      (click)="sendRequestFilter()"
      [disabled]="
        filterData.length === 0 &&
        (searchValue.trim().length < 3 || !!searchTypeFilter)
      "
      class="btn btn-accent"
    >
      {{ 'FILTERS.APPLY' | translate }}
    </button>
    <button
      (click)="resetAllFilters()"
      [disabled]="
        filterData.length === 0 &&
        (searchValue.trim().length < 3 || !!searchTypeFilter)
      "
      class="btn btn-link"
    >
      {{ 'FILTERS.RESET' | translate }}
    </button>
  </div>
</div>
